import { useCheckoutStore } from '@/store/checkoutStore'
import { useFlowStore } from '@/store/flowStore'
import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

const SuccessRoute = lazyRouteComponent(() => import('@/features/success/Success'), 'Success')

export const Route = createFileRoute('/sucesso')({
  component: SuccessRoute,
  beforeLoad: () => {
    // Check if returning from Pagarme with orderId in query params
    const urlParams = new URLSearchParams(window.location.search)
    const queryOrderId = urlParams.get('orderId')

    if (queryOrderId) {
      useCheckoutStore.getState().setOrderId(queryOrderId)
      return
    }

    const { contactMethod } = useFlowStore.getState()
    const { orderId } = useCheckoutStore.getState()
    if (!contactMethod && !orderId) {
      throw redirect({ to: '/objetivo' })
    }
  },
})
